import React from "react";
import PageTitle from "../components/PageTitle";
import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import FAQ from "../sections/pricing/FAQ";
// import PricingTable from "../sections/pricing/PricingTable";

const Pricing = (props) => {
  return (
    <>
      <PageWrapper headerDark footerDark>
        <Seo
          title="Opqo | FAQ | Mobile for Maximo"
          description="Frequently asked questions."
          pathname={props.location.pathname}
        />
        <PageTitle title="Frequently Asked Questions" titleDark>
        </PageTitle>
        {/* <PricingTable /> */}
        <FAQ />
      </PageWrapper>
    </>
  );
};
export default Pricing;
